export default __webpack_public_path__ + "static/media/hht2_ep17_timeline_q03_a.2e79a97a.png";